/**
 * VOIP Services Index
 * Re-exports all VOIP service functions for easy importing
 */

export {
    initiateVoisoCall,
    initiateCommpeakCall,
    initiateCoperatoCall,
    initiateSquareTalkCall,
    initiateOctellaCall,
    initiateCccCall,
    getVoisoCallStatus,
    getCommpeakCallStatus,
    getCoperatoCallStatus,
    getSquareTalkCallStatus,
    endCall,
    logCallActivity,
    handleCallCompletion
} from "./voipService";
